// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"593dc211","146":"efcf5a05","182":"ac62a698","218":"d31f9a74","312":"b1d0992f","508":"823cbab2","640":"298b6aaf","733":"0e5e2eea","800":"d79d84e4","821":"7b3b2b1a","975":"2602a131"}[chunkId] + ".chunk.js";
};